import React from 'react';

type Status = 'loading' | 'success' | 'error' | 'idle';

const dotColor = (s: Status) => {
  switch (s) {
    case 'success': return 'var(--green)';
    case 'error':   return 'var(--rose)';
    case 'loading': return 'var(--accent)';
    default:        return 'var(--ink-mute)';
  }
};

interface StatusPanelProps {
  title: string;
  status: Status;
  message?: string;
  children?: React.ReactNode;
}

const StatusPanel: React.FC<StatusPanelProps> = ({ title, status, message, children }) => (
  <section
    className="ds-section"
    style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', padding: '48px 0' }}
  >
    <div style={{ width: '100%', maxWidth: 560, padding: '0 24px' }}>
      <div className="dash">
        <div className="dash__bar">
          <span className="dot g" />
          <span className="dot y" />
          <span className="dot r" />
          <span className="title">{title}</span>
          <span className="spacer" />
          <span
            className="pill-mini"
            style={{ color: dotColor(status), textTransform: 'uppercase', letterSpacing: '0.06em' }}
          >
            {status === 'loading' ? 'processing' : status}
          </span>
        </div>
        <div
          style={{
            padding: 32,
            fontFamily: 'var(--font-mono)',
            fontSize: 13,
            color: 'var(--ink-dim)',
            lineHeight: 1.7,
            minHeight: 120,
          }}
        >
          {status === 'loading' && (
            <div style={{ color: 'var(--accent)' }}>{'> connecting…'}</div>
          )}
          {message && (
            <div
              style={{
                whiteSpace: 'pre-wrap',
                color: status === 'error' ? 'var(--rose)' : 'var(--ink)',
              }}
            >
              {status === 'success' ? '◆ ' : status === 'error' ? '✕ ' : ''}
              {message}
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  </section>
);

export default StatusPanel;
